import { emptyObj } from '@beef/utils';

const getFttbTvChannelsData = (state) => state.external?.fttbTvChannelsData || emptyObj;

const getTvChannelsState = (state) => getFttbTvChannelsData(state).state;
export const getTvChannelsData = (state) => getFttbTvChannelsData(state).tvChannelsData;
export const isTvChannelsIsLoaded = (state) => getTvChannelsState(state) === 'loaded';
